import { Component, ElementRef, EventEmitter, input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";

@Component({
    selector: "ev-dropdown-menu",
    templateUrl: "./ev-dropdown-menu.component.html",
    styleUrl: "./ev-dropdown-menu.component.scss",
})
export class EvDropdownMenuComponent implements OnInit, OnChanges {
    @ViewChild("dropDownMenu") dropDownElement: ElementRef;
    items = input.required<ISearchDropDownItem[]>();
    asDotted = input(false);
    theme = input("default");
    dynamicHeight = input(false);
    showSubInSelected = input(false);
    fromRight = input(false);
    right = input<string>();
    top = input<string>();
    alwaysShow = input(false);
    autoPopinView = input(false);
    useBoxShadow = input(false);
    header = input("vis");
    showHeader = input(true);
    @Output() onSelectedItem: EventEmitter<ISearchDropDownItem> = new EventEmitter<ISearchDropDownItem>();
    @Output() onExpanded: EventEmitter<boolean> = new EventEmitter<boolean>();

    selectedItem: ISearchDropDownItem = null;
    showMenu = false;

    ngOnInit(): void {
        this.updateSelected();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateSelected();
    }

    updateSelected(): ISearchDropDownItem {
        const itemsArray = this.items() || [];
        this.selectedItem = itemsArray.find((s) => s.isSelected);
        return this.selectedItem;
    }

    openMenu(): void {
        this.showMenu = true;
    }
    closeMenu(): void {
        this.setMenuStatus(false);
    }

    setSelected(key: string): void {
        this.setMenuStatus(false);
        this.resetSelected();
        const matchItem: ISearchDropDownItem = this.items().find((s) => s.key === key);

        if (matchItem) {
            matchItem.isSelected = true;
            const selectedItem: ISearchDropDownItem = this.updateSelected();
            this.onSelectedItem.next(selectedItem);
        }
    }

    private setMenuStatus(opened: boolean): void {
        this.showMenu = opened;
        this.onExpanded.emit(opened);
    }

    private resetSelected(): void {
        this.items().forEach((s) => (s.isSelected = false));
    }
}

export interface ISearchDropDownItem {
    maintext: string;
    key: string;
    subtext?: string;
    isSelected?: boolean;
    data?: any;
}
